export { default as FlightDetailsSkeleton } from "./FlightDetailsSkeleton.jsx"
